import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "submenu", "submenuTrigger", "userMenu"]

  connect() {
    // Close menus when clicking outside
    this.boundCloseMenus = this.closeMenus.bind(this)
    document.addEventListener('click', this.boundCloseMenus)
  }

  disconnect() {
    document.removeEventListener('click', this.boundCloseMenus)
  }

  toggleMobile(event) {
    event.stopPropagation()
    const isOpen = this.menuTarget.classList.toggle('open')
    this.mobileTrigger = event.currentTarget
    event.currentTarget.setAttribute('aria-expanded', isOpen)
  }

  toggleSubmenu(event) {
    event.stopPropagation()
    const trigger = event.currentTarget
    const submenu = trigger.nextElementSibling

    // Close other submenus
    this.submenuTargets.forEach(menu => {
      if (menu !== submenu) {
        menu.classList.remove('open')
        const otherTrigger = menu.previousElementSibling
        if (otherTrigger) {
          otherTrigger.setAttribute('aria-expanded', 'false')
        }
      }
    })

    // Toggle current submenu
    submenu.classList.toggle('open')
    const isOpen = submenu.classList.contains('open')
    trigger.setAttribute('aria-expanded', isOpen)
  }

  toggleUserMenu(event) {
    event.stopPropagation()
    const isOpen = this.userMenuTarget.classList.toggle('open')
    this.userMenuTrigger = event.currentTarget
    event.currentTarget.setAttribute('aria-expanded', isOpen)
  }

  closeMenus(event) {
    // Close the mobile sidebar when clicking outside it (e.g. the backdrop)
    if (this.hasMenuTarget && !this.menuTarget.contains(event.target)) {
      this.menuTarget.classList.remove('open')
      if (this.mobileTrigger) this.mobileTrigger.setAttribute('aria-expanded', 'false')
    }

    // Close the user menu when clicking outside it
    if (this.hasUserMenuTarget && !this.userMenuTarget.contains(event.target)) {
      this.userMenuTarget.classList.remove('open')
      if (this.userMenuTrigger) this.userMenuTrigger.setAttribute('aria-expanded', 'false')
    }

    // Close submenus
    this.submenuTargets.forEach(submenu => {
      submenu.classList.remove('open')
      const trigger = submenu.previousElementSibling
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false')
      }
    })
  }
}
